export const PAYMENT_LINKS_WRITE = 'payment-links-write';
export const INVOICES_WRITE = 'invoices-write';
export const INVOICES_EDIT_OWNED = 'invoices-edit-owned';
export const QUOTE_CREATE = 'quote-create';
export const SUBSCRIPTIONS_WRITE = 'subscriptions-write';